module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-3000.04884657.svg";